import { useMemo, useState } from 'react';
import { filterRows, nextSort, sortRows } from './tableModel';

// The sort and the column filters of one table. Gives the rows to show (filtered, then sorted) and what the headers need.
//   rows     all the rows
//   columns  the columns (see tableModel.js); keep the list the same between renders (define it outside the component or in useMemo)
//   initial  the sort to start with, or null for the order the rows came in
//   initialFilters  column filters already set when the table first shows, for example { state: 'open' }; "clear" removes every filter, these too
export function useTableView(rows, columns, initial = null, initialFilters = {}) {
  const [sort, setSort] = useState(initial);
  const [filters, setFilters] = useState(initialFilters);
  const shown = useMemo(() => sortRows(filterRows(rows, columns, filters), columns, sort), [rows, columns, filters, sort]);
  const active = Object.keys(filters).filter((k) => filters[k] !== '' && filters[k] !== undefined).length;
  return {
    rows: shown,
    all: rows,
    columns,
    sort,
    filters,
    active,
    toggleSort: (key) => setSort((s) => nextSort(s, key)),
    setFilter: (key, value) => setFilters((f) => ({ ...f, [key]: value })),
    clear: () => { setFilters({}); setSort(initial); },
  };
}
